import * as React from "react";
import styled from "styled-components";
import Gettext from "../common/Gettext";
import errorImg from "./images/error.png";

// styled
const Flex = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
`;

const Overlay = styled(Flex)`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  padding: 2.5em;
  font-size: 10px;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.5);
  //user-select: none;
  z-index: 20000;
  overflow: auto;

  @media (max-width: 959px) {
    padding: 1.5em;
    font-size: 5px;
  }
`;

const Popup = styled(Flex)`
  position: relative;
  flex-shrink: 1;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  max-width: 65em;
  max-height: 100%;
  margin: 0 auto;
  text-align: center;
  background-color: #fff;
  border-radius: 0.5em;
  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);
  overflow: hidden;
`;

const ExclamationContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex: 0 0 20%;
  padding: 15px;
  background-color: #e6e6e6;
`;

const ExclamationPoint = styled.div`
  width: 100%;
  align-self: stretch;
  background: url(${errorImg}) center no-repeat;
  background-size: contain;
`;

const Content = styled(Flex)`
  justify-content: space-around;
  flex: 1 1 80%;
  align-self: stretch;
  padding: 30px 30px 25px;

  @media (max-height: 200px) {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

const Message = styled.div`
  padding-bottom: 1em;
  font-weight: 400;
  font-size: 3em;
  line-height: 1.25;
  text-align: center;
  color: #343434;

  @media (max-height: 200px) {
    padding-bottom: 10px;
    font-size: 20px;
  }

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const ButtonContainer = styled(Flex)`
  @media (min-width: 568px) {
    flex-direction: row;
  }
`;

export const Button = styled.button`
  min-width: 165px;
  min-height: 39px;
  margin: 0 auto;
  padding: 0 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: #fff;
  background-color: #887d96;
  background: linear-gradient(to bottom, #887d96, #605073);
  border: none;
  border-radius: 8px;
  cursor: pointer;

  :hover {
    color: #fff;
    background-color: #605073;
    background: linear-gradient(to bottom, #605073, #887d96);
    outline: none;
  }

  :hover,
  :focus,
  :active {
    outline: none;
  }

  @media (min-width: 568px) {
    :not(:first-of-type) {
      margin-left: 10px;
    }
  }
  @media (max-width: 567px) {
    :not(:first-of-type) {
      margin-top: 5px;
    }
  }
`;

const Close = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  width: 18px;
  height: 18px;
  color: #a0a7b2;
  background-size: cover;
  transition: all 0.3s ease;
  cursor: pointer;

  @media (max-width: 480px) {
    top: 15px;
    right: 15px;
  }

  :before,
  :after {
    content: "";
    position: absolute;
    top: -1px;
    left: 50%;
    width: 0px;
    height: 24px;
    border-left: 2px solid;
  }

  :before {
    transform: translateX(-50%) rotate(45deg);
    transform-origin: 100%;
  }

  :after {
    transform: translateX(-50%) rotate(-45deg);
    transform-origin: 0%;
  }

  :hover {
    color: #60a31c;
  }
`;

type Props = {
  onDismiss: () => void,
  style?: Object,
  message: string | React.Node,
  children?: any
};

function PopupFailed(props: Props) {
  return (
    <Overlay style={props.style}>
      <Popup>
        <Close onClick={props.onDismiss} />
        <ExclamationContainer>
          <ExclamationPoint />
        </ExclamationContainer>
        <Content>
          <Message>{props.message}</Message>
          <ButtonContainer>
            <Button onClick={props.onDismiss}>
              <Gettext>OK</Gettext>
            </Button>
            {props.children}
          </ButtonContainer>
        </Content>
      </Popup>
    </Overlay>
  );
}

export default PopupFailed;



// WEBPACK FOOTER //
// ./src/components/ErrorPopup/Error.js